import React from 'react';
import { Box, Typography } from '@mui/material';
import { SaveVendorButton } from '../actions';
import GoBackButton from '../../../../common/components/styled-ui-elements/GoBackButton';

export const VendorEditHeader: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="h5"
            component="h1"
            fontWeight={600}
            color="#1e293b"
            sx={{ mb: 0.5 }}
          >
            Edit Vendor
          </Typography>
          <Typography
            variant="body2"
            color="#64748b"
            sx={{ fontSize: '0.9rem' }}
          >
            Update vendor details and contact information
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <SaveVendorButton label="Save Changes" successMessage="Vendor updated successfully!" />
          <GoBackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default VendorEditHeader;
